import MapIcon from '@mui/icons-material/Map';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import cx from 'classnames';
import React, { useMemo, useState } from 'react';
import Styles from './LayerToggle.scss';

interface ILayerToggleProps {
    initialLayer: string;
    onToggle: (newMapType: string) => void;
}

const roadLayer = {
    icon: <MapIcon />,
    layerOption: 'roadmap',
};
const satelliteLayer = {
    icon: <SatelliteAltIcon />,
    layerOption: 'satellite',
};

export const LayerToggle = (props: ILayerToggleProps) => {
    const [hasFlipped, setHasFlipped] = useState<boolean>(false);

    const frontOption = useMemo(() => {
        return props.initialLayer === 'roadmap' ? roadLayer : satelliteLayer;
    }, [props.initialLayer]);

    const backOption = useMemo(() => {
        return props.initialLayer === 'roadmap' ? satelliteLayer : roadLayer;
    }, [props.initialLayer]);

    const handleToggle = () => {
        const newOption = hasFlipped ? frontOption : backOption;
        props.onToggle(newOption.layerOption);
        setHasFlipped(!hasFlipped);
    };

    return (
        <div
            className={cx(
                Styles.flipContainer,
                hasFlipped ? Styles.flip : null
            )}
            onClick={handleToggle}
            title="Toggle Basemap"
        >
            <div className={Styles.flipper}>
                <div className={Styles.front}>
                    <div className={Styles.innerContainer}>
                        {frontOption.icon}
                    </div>
                </div>
                <div className={Styles.back}>
                    <div className={Styles.innerContainer}>
                        {backOption.icon}
                    </div>
                </div>
            </div>
        </div>
    );
};
